import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { surveyReportTokens } from "../../lib/database";
import { generateSurveyReport } from "../customer-database/utils/generateSurveyReport";

/**
 * Public page for survey report PDF download via token link (e.g. from Excel export).
 * No login required; security is the unguessable token (UUID) stored in Supabase.
 */
const SurveyReportPublic = () => {
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const rawToken = token != null ? String(token).trim() : "";
    const decodedToken = rawToken ? decodeURIComponent(rawToken) : "";
    if (!decodedToken) {
      setStatus("error");
      setMessage("Invalid link.");
      return;
    }
    surveyReportTokens
      .getReportByToken(decodedToken)
      .then(({ data, error: rpcError }) => {
        if (rpcError) {
          setStatus("error");
          const msg = rpcError?.message || String(rpcError);
          setMessage(msg.includes("does not exist") ? "Report link setup incomplete. Please run the survey report tokens SQL in Supabase." : msg);
          return;
        }
        if (!data?.customer || !data?.survey) {
          setStatus("error");
          setMessage("Report not found or link invalid.");
          return;
        }
        return generateSurveyReport(data.customer, data.survey, null, null).then(() => {
          setStatus("success");
          setMessage("Survey report downloaded. You can close this page.");
        });
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err?.message || "Failed to load or generate report.");
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center">
        {status === "loading" && (
          <p className="text-gray-600">Loading survey report...</p>
        )}
        {status === "success" && (
          <p className="text-green-700 font-medium">{message}</p>
        )}
        {status === "error" && (
          <p className="text-red-600 font-medium">{message}</p>
        )}
      </div>
    </div>
  );
};

export default SurveyReportPublic;
